import { takeEvery, takeLatest, fork, put, all, call, select } from "redux-saga/effects";
import {
    getParentsError,
    getParentsSuccessful,
    addParentError,
    addParentSuccessful,
    showAddParentModalSuccess,
    removeParentError,
    removeParentSuccess,
    getParents,
    editParentError,
    editParentSuccess,
    setParentQuery
} from "./actions";
import ParentService from "./service";
import { ParentActionTypes } from "./actionTypes";

// Selector to get the parent query state from the Redux store.
export const getParentQuery = state => state.Parent.query;

export function* get({payload}) {
    try {
        // Get the current query from the Redux store.
        const storedQuery = yield select(getParentQuery);
        // The payload from the action can override the stored query for this specific call.
        const finalPayload = { ...storedQuery, ...payload };
        const response = yield call(ParentService.getParents, finalPayload);
        yield put(getParentsSuccessful(response));
        yield put(setParentQuery(finalPayload));
    } catch (error) {
        yield put(getParentsError(error));
    }
}

export function* addParent({ payload: parent }) {
    try {
        const response = yield call(ParentService.addParent, parent);
        yield put(addParentSuccessful(response));
        // Refresh with type: 'PARENT' to ensure correct endpoint
        yield put(getParents({ type: 'PARENT' }));
    } catch (error) {
        yield put(addParentError(error));
    }
}

export function* showAddParent({ payload: showModal }) {
    yield put(showAddParentModalSuccess(showModal));
}

export function* removeParent({ payload: parentId }) {
    try {
        const response = yield call(ParentService.removeParent, parentId);
        yield put(removeParentSuccess(response));
        // Refresh with type: 'PARENT' to ensure correct endpoint
        yield put(getParents({ type: 'PARENT' }));
    } catch (error) {
        yield put(removeParentError(error));
    }
}

export function* edit({ payload: parent }) {
    try {
        const response = yield call(ParentService.editParent, parent);
        yield put(editParentSuccess(response));
        // Refresh with type: 'PARENT' to ensure correct endpoint
        yield put(getParents({ type: 'PARENT' }));
    } catch (error) {
        yield put(editParentError(error));
    }
}

export function* watchGetParent() {
    yield takeLatest(ParentActionTypes.PARENT_LIST_GET, get);
}

export function* watchAddParent() {
    yield takeEvery(ParentActionTypes.PARENT_ADD, addParent);
}

export function* watchShowAddParentModal() {
    yield takeEvery(ParentActionTypes.PARENT_ADD_MODAL, showAddParent);
}

export function* watchRemoveParent() {
    yield takeEvery(ParentActionTypes.PARENT_REMOVE, removeParent);
}

export function* watchEditParent() {
    yield takeEvery(ParentActionTypes.PARENT_EDIT, edit);
}

function* parentsSaga() {
    yield all([
        fork(watchGetParent),
        fork(watchAddParent),
        fork(watchShowAddParentModal),
        fork(watchRemoveParent),
        fork(watchEditParent)
    ]);
}

export default parentsSaga;
